import { render, staticRenderFns } from "./Selection1.vue?vue&type=template&id=1ed84405&"
import script from "./Selection1.vue?vue&type=script&lang=js&"
export * from "./Selection1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports